import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useUpdateLogisticAdviceMutation } from '../../../../../entities/logistic/logisticTasks/redux/logisticTasks.api';
import { STATUS } from '../../constants/filters';

function Actions({ adviceId, solutions }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [updateLogisticAdvice] = useUpdateLogisticAdviceMutation();

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleChooseSolution = async (caseNumber) => {
    await updateLogisticAdvice({
      id: adviceId,
      body: { logisticAdvicesId: adviceId, solutionVariantNumber: caseNumber, status: STATUS.INPROGRESS },
    });
    handleMenuClose();
  };

  const handleCancel = async () => {
    await updateLogisticAdvice({
      id: adviceId,
      body: { logisticAdvicesId: adviceId, status: STATUS.CANCELED },
    });
    handleMenuClose();
  };

  return (
    <div>
      <IconButton onClick={handleMenuOpen} size="small">
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Menu id="solution-menu" anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        {solutions.length > 0 ? (
          solutions.map((solution) => (
            <MenuItem key={solution.logisticAdviceCasesId} onClick={() => handleChooseSolution(solution.caseNumber)}>
              {solution.caseText}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>Нет решений</MenuItem>
        )}
        <MenuItem
          onClick={() => {
            handleCancel();
            handleMenuClose();
          }}
          sx={{ color: 'red' }}
        >
          Отменить
        </MenuItem>
      </Menu>
    </div>
  );
}

Actions.propTypes = {
  adviceId: PropTypes.number.isRequired,
  solutions: PropTypes.arrayOf(PropTypes.string),
};

Actions.defaultProps = {
  solutions: [],
};
export default Actions;
